import { dataCivil, formatarDataBr, formatarDataHoraBr } from "./date.js";

const SEM_DATA = "sem data";
const USUARIO_DESCONHECIDO = "usuário não identificado";

/**
 * Retorna os logs de fim previsto da tarefa ou da entrega em ordem de registro.
 * @param {object|null|undefined} entidade
 * @returns {Array<object>}
 */
export function logsFimPrevisto(entidade) {
  const logs = entidade?.logs_fim_previsto;
  if (!Array.isArray(logs)) return [];
  return logs
    .filter(Boolean)
    .slice()
    .sort((a, b) => Number(a.id ?? 0) - Number(b.id ?? 0));
}

/**
 * Data de fim previsto original da tarefa ou da entrega, sem distinguir se veio da criação
 * ou do primeiro preenchimento.
 * @param {object|null|undefined} entidade
 * @returns {string|null}
 */
export function fimPrevistoOriginal(entidade) {
  const [primeiro] = logsFimPrevisto(entidade);
  if (!primeiro) return null;
  return primeiro.valor_original || primeiro.valor_antigo || primeiro.valor_novo || null;
}

/**
 * O chip vermelho só faz sentido quando a data atual deixou de ser a original.
 * @param {object|null|undefined} entidade
 * @param {string|Date|null|undefined} dataAtual
 * @returns {boolean}
 */
export function exibirFimPrevistoOriginal(entidade, dataAtual) {
  const original = dataCivil(fimPrevistoOriginal(entidade));
  if (!original) return false;
  return dataCivil(dataAtual) !== original;
}

/**
 * Alterações de data, ou seja, os registros em que uma data já existente foi trocada.
 * @param {object|null|undefined} entidade
 * @returns {Array<object>}
 */
export function alteracoesFimPrevisto(entidade) {
  return logsFimPrevisto(entidade).filter((log) => !!log.valor_antigo);
}

function autoria(log) {
  const usuario = log?.usuario?.name || USUARIO_DESCONHECIDO;
  if (!log?.created_at) return usuario;
  return `${usuario} em ${formatarDataHoraBr(log.created_at)}`;
}

/**
 * Texto do tooltip: data original seguida de todas as alterações registradas.
 * @param {object|null|undefined} entidade
 * @returns {string}
 */
export function tituloFimPrevistoOriginal(entidade) {
  const logs = logsFimPrevisto(entidade);
  if (!logs.length) return "";

  const original = formatarDataBr(fimPrevistoOriginal(entidade), SEM_DATA);
  const definicao = logs[0].valor_antigo ? null : logs[0];
  const linhas = [
    definicao
      ? `Fim previsto original: ${original} (${autoria(definicao)})`
      : `Fim previsto original: ${original}`,
  ];

  const alteracoes = alteracoesFimPrevisto(entidade);
  if (alteracoes.length) {
    linhas.push("Alterações:");
    alteracoes.forEach((log) => {
      const de = formatarDataBr(log.valor_antigo, SEM_DATA);
      const para = formatarDataBr(log.valor_novo, SEM_DATA);
      linhas.push(`${de} → ${para} (${autoria(log)})`);
    });
  }

  return linhas.join("\n");
}
